import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import { tv } from "tailwind-variants";

type Props = PropsWithChildren<{
  className?: string;
  columns?: 1 | 2 | 3;
}>;

const style = tv({
  base: "grid gap-24",
  variants: {
    columns: {
      1: "grid-cols-1",
      2: "grid-cols-2",
      3: "grid-cols-3",
    },
  },
});

export const MultiColumnInputBox: FC<Props> = ({
  children,
  className,
  columns = 2,
}) => {
  return <div className={clsx(style({ columns }), className)}>{children}</div>;
};
